import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { useMotivo } from './hooks/useMotivo';
import { useCitaNueva } from './hooks/useCitaNueva';
import { useCitaEditar } from './hooks/useCitaEditar';
import { useCitaPosponer } from './hooks/useCitaPosponer';
import { useDatosGenerales } from './hooks/useDatosGenerales';

import { useForm, useFormValidation } from '../../../hooks';

import { PrimaryButton, LightButton, DateInput, TimeInput, NumberInput, TextAreaInput, ReactSelectSingleKeyInput, TextInput, ReactSelectSingleInput, EmailInput, TelInput, Forbidden, Loader, Error } from '../../../components';

import { eliminarUndefined } from '../../../helpers/eliminarUndefined';

import styles from '../Modals.module.css';

export const CitaPacienteModal = ({ paciente: pacienteAux, cita = null, hide, posponer = false }) => {

    const location = useLocation();

    const { permisos } = useSelector(state => state.auth);

    const [inactivoFlag, setInactivoFlag] = useState(false);
    const [horarioFlag, setHorarioFlag] = useState(false);
    const [empalmadaFlag, setEmpalmadaFlag] = useState(false);

    const [generoOptions, setGeneroOptions] = useState(['Masculino', 'Femenino']);

    const activeInactivoFlag = () => {
        setInactivoFlag(true);
    }

    const activeHorarioFlag = () => {
        setHorarioFlag(true);
    }

    const activeEmpalmadaFlag = () => {
        setEmpalmadaFlag(true);
    }

    const { createCitaMutation: { mutate: createCita } } = useCitaNueva(pacienteAux);
    const { updateCitaMutation: { mutate: updateCita } } = useCitaEditar(pacienteAux);
    const { posponerCitaMutation: { mutate: posponerCita } } = useCitaPosponer(pacienteAux);

    const { motivoQuery: { isLoading, isError, data: motivos } } = useMotivo();

    const { datosGeneralesQuery: { isLoading: isLoadingDatosGenerales, isError: isErrorDatosGenerales, data: configuracionDatosGenerales } } = useDatosGenerales();

    const { paciente, fecha, hora, motivo, comentario, nombre, apellidoPaterno, apellidoMaterno, fechaNacimiento, genero, email, celular, onInputChange, onResetForm } = useForm({ paciente: pacienteAux, fecha: (cita !== null) ? cita.diaSinFormato : '', hora: (cita !== null) ? cita.horaSinFormato : '', motivo: (cita !== null) ? cita.motivo._id : '', comentario: (cita !== null && typeof cita.comentario !== 'undefined') ? cita.comentario : '', nombre: (cita !== null && typeof cita.paciente !== 'undefined' && cita.paciente._id === '0') ? cita.nombre : undefined, apellidoPaterno: (cita !== null && typeof cita.paciente !== 'undefined' && cita.paciente._id === '0') ? cita.apellidoPaterno : undefined, apellidoMaterno: (cita !== null && typeof cita.paciente !== 'undefined' && cita.paciente._id === '0') ? cita.apellidoMaterno : undefined, fechaNacimiento: (cita !== null && typeof cita.paciente !== 'undefined' && cita.paciente._id === '0') ? cita.fechaNacimiento : undefined, genero: (cita !== null && typeof cita.paciente !== 'undefined' && cita.paciente._id === '0') ? cita.genero : undefined, email: (cita !== null && typeof cita.paciente !== 'undefined' && cita.paciente._id === '0') ? cita.email : undefined, celular: (cita !== null && typeof cita.paciente !== 'undefined' && cita.paciente._id === '0') ? cita.celular : undefined });

    const { duracion, onInputChange: onInputChangeSecond, onResetForm: onResetFormSecond } = useForm({ duracion: (cita !== null) ? cita.duracion : 0 });

    const { isFormValid, formValidationStatus, formFields, startFormValidation, setFormFieldValidation, onResetValidation } = useFormValidation([{field: 'fecha', default: true}, {field: 'hora', default: true}, {field: 'motivo', default: true}, {field: 'comentario', default: true}, {field: 'nombre', default: true}, {field: 'apellidoPaterno', default: true}, {field: 'apellidoMaterno', default: true}, {field: 'fechaNacimiento', default: true}, {field: 'genero', default: true}, {field: 'email', default: true}, {field: 'celular', default: true}]);

    const { isFormValid: isFormValidSecond, formValidationStatus: formValidationStatusSecond, formFields: formFieldsSecond, startFormValidation: startFormValidationSecond, setFormFieldValidation: setFormFieldValidationSecond, onResetValidation: onResetValidationSecond } = useFormValidation([{field: 'duracion', default: true}]);

    const handleMotivoChange = (e) => {
        setInactivoFlag(false);
        setHorarioFlag(false);
        setEmpalmadaFlag(false);
        onInputChange(e);

        onInputChangeSecond({ target: { name: 'duracion', value: motivos.find(motivo => String(motivo._id) === String(e.target.value)).duracion } });
    }

    const handleInputChange = (e) => {
        setInactivoFlag(false);
        setHorarioFlag(false);
        setEmpalmadaFlag(false);
        onInputChange(e);
    }

    const handleInputChangeSecond = (e) => {
        setInactivoFlag(false);
        setHorarioFlag(false);
        setEmpalmadaFlag(false);
        onInputChangeSecond(e);
    }

    const handleSuccessSubmit = () => {
        onResetForm();
        onResetValidation();
        onResetFormSecond();
        onResetValidationSecond();
    }

    useEffect(() => {
        let opcionesGenero = ['Masculino', 'Femenino'];
        if(typeof configuracionDatosGenerales !== 'undefined' && typeof configuracionDatosGenerales.fichaIdentificacion !== 'undefined' && typeof configuracionDatosGenerales.fichaIdentificacion.genero !== 'undefined'){
            if(typeof configuracionDatosGenerales.fichaIdentificacion.generoOtro !== 'undefined' && configuracionDatosGenerales.fichaIdentificacion.generoOtro){
            opcionesGenero.push('Otro');
            }
            if(typeof configuracionDatosGenerales.fichaIdentificacion.generoPrefieroNoDecirlo !== 'undefined' && configuracionDatosGenerales.fichaIdentificacion.generoPrefieroNoDecirlo){
            opcionesGenero.push('Prefiero no decirlo');
            }
        }
        setGeneroOptions(opcionesGenero);
    }, [configuracionDatosGenerales])

    const onSubmit = async ( event ) => {
        event.preventDefault();

        if(formValidationStatus === 'checked' && isFormValid != null && isFormValid && formValidationStatusSecond === 'checked' && isFormValidSecond != null && isFormValidSecond){
            if(cita === null){
                createCita({ data: eliminarUndefined({ paciente, fecha, hora, motivo, duracion, comentario, inactivoConfirmacion: inactivoFlag, horarioConfirmacion: horarioFlag, empalmadaConfirmacion: empalmadaFlag }, { comentario: undefined }), onSuccess: handleSuccessSubmit, onComplete: hide, onInactivo: activeInactivoFlag, onHorario: activeHorarioFlag, onEmpalmada: activeEmpalmadaFlag});
            }else if(!posponer){
                updateCita({ id: cita._id, data: eliminarUndefined({ paciente, fecha, hora, motivo, duracion, comentario, nombre: (cita.paciente._id === '0') ? nombre : '', apellidoPaterno: (cita.paciente._id === '0') ? apellidoPaterno : '', apellidoMaterno: (cita.paciente._id === '0') ? apellidoMaterno : '', fechaNacimiento: (cita.paciente._id === '0') ? fechaNacimiento : '', genero: (cita.paciente._id === '0') ? genero : '', email: (cita.paciente._id === '0') ? email : '', celular: (cita.paciente._id === '0') ? celular : '', inactivoConfirmacion: inactivoFlag, horarioConfirmacion: horarioFlag, empalmadaConfirmacion: empalmadaFlag, posponer: (!location.pathname.includes('/paciente/citas')) ? true : false }, { nombre: (cita.paciente._id === '0') ? true : undefined, apellidoPaterno: (cita.paciente._id === '0') ? true : undefined, apellidoMaterno: (cita.paciente._id === '0') ? true : undefined, fechaNacimiento: (cita.paciente._id === '0') ? true : undefined, genero: (cita.paciente._id === '0') ? true : undefined, email: (cita.paciente._id === '0') ? true : undefined, celular: (cita.paciente._id === '0') ? true : undefined }), onSuccess: handleSuccessSubmit, onComplete: hide, onInactivo: activeInactivoFlag, onHorario: activeHorarioFlag, onEmpalmada: activeEmpalmadaFlag});
            }else{
                posponerCita({ id: cita._id, data: { paciente, fecha, hora, inactivoConfirmacion: inactivoFlag, horarioConfirmacion: horarioFlag, empalmadaConfirmacion: empalmadaFlag }, onSuccess: handleSuccessSubmit, onComplete: hide, onInactivo: activeInactivoFlag, onHorario: activeHorarioFlag, onEmpalmada: activeEmpalmadaFlag});
            }
        }else{
            startFormValidation();
            startFormValidationSecond();
        }

    }

    return (permisos.citaCreate || permisos.citaUpdate) ? (
        <>
        {(isLoading || isLoadingDatosGenerales)
            ? <Loader />
            : <>
                {(isError || isErrorDatosGenerales)
                    ? <Error />
                    : <>
                        <div>
                            <form onSubmit={ onSubmit }>
                                <div className="row mb-3">
                                    <div className="col">
                                        <div className={styles.modalHeader}>{(cita === null) ? "Cita nueva" : ((!posponer) ? "Editar cita" : "Posponer cita")}</div>
                                    </div>
                                </div>
                                {(cita !== null && typeof cita.paciente !== 'undefined' && cita.paciente._id === '0') &&
                                <div className="row">
                                    <div className="col-md-12 col-lg-4">
                                        <TextInput
                                            formFieldStatus={ formFields['nombre'].status }
                                            label="Nombre(s)"
                                            name="nombre"
                                            onChange={ onInputChange }
                                            required={ true }
                                            requiredIndicator={ true }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ nombre }
                                        />
                                    </div>
                                    <div className="col-md-12 col-lg-4">
                                        <TextInput
                                            formFieldStatus={ formFields['apellidoPaterno'].status }
                                            label="Apellido paterno"
                                            name="apellidoPaterno"
                                            onChange={ onInputChange }
                                            required={ true }
                                            requiredIndicator={ true }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ apellidoPaterno }
                                        />
                                    </div>
                                    {(configuracionDatosGenerales.fichaIdentificacion.apellidoMaterno) &&
                                    <div className="col-md-12 col-lg-4">
                                        <TextInput
                                            formFieldStatus={ formFields['apellidoMaterno'].status }
                                            label="Apellido materno"
                                            name="apellidoMaterno"
                                            onChange={ onInputChange }
                                            required={ false }
                                            requiredIndicator={ false }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ apellidoMaterno }
                                        />
                                    </div>
                                    }
                                    <div className="col-md-12 col-lg-4">
                                        <DateInput
                                            formFieldStatus={ formFields['fechaNacimiento'].status }
                                            label="Fecha de nacimiento"
                                            name="fechaNacimiento"
                                            onChange={ onInputChange }
                                            required={ true }
                                            requiredIndicator={ true }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ fechaNacimiento }
                                        />
                                    </div>
                                    <div className="col-md-12 col-lg-4">
                                        <ReactSelectSingleInput
                                            formFieldStatus={ formFields['genero'].status }
                                            label="Género"
                                            name="genero"
                                            onChange={ onInputChange }
                                            required={true}
                                            requiredIndicator={true}
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={genero}
                                            values={generoOptions}
                                        />
                                    </div>
                                    <div className="col-md-12 col-lg-4">
                                        <EmailInput
                                            formFieldStatus={ formFields['email'].status }
                                            label="Correo electrónico"
                                            name="email"
                                            onChange={ onInputChange }
                                            required={ true }
                                            requiredIndicator={ true }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ email }
                                        />
                                    </div>
                                    <div className="col-md-12 col-lg-4">
                                        <TelInput
                                            formFieldStatus={ formFields['celular'].status }
                                            label="Teléfono móvil"
                                            name="celular"
                                            onChange={ onInputChange }
                                            required={ true }
                                            requiredIndicator={ true }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ celular }
                                        />
                                    </div>
                                </div>
                                }
                                <div className="row">
                                    <div className="col-6">
                                        <DateInput
                                            formFieldStatus={ formFields['fecha'].status }
                                            label="Fecha"
                                            name="fecha"
                                            onChange={ handleInputChange }
                                            required={ cita !== null }
                                            requiredIndicator={ cita !== null }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ fecha }
                                        />
                                    </div>
                                    <div className="col-6">
                                        <TimeInput
                                            formFieldStatus={ formFields['hora'].status }
                                            label="Hora"
                                            name="hora"
                                            onChange={ handleInputChange }
                                            required={ cita !== null }
                                            requiredIndicator={ cita !== null }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ hora }
                                        />
                                    </div>
                                </div>
                                {(cita === null || !posponer) && <>
                                <div className="row">
                                    <div className="col-6">
                                        <ReactSelectSingleKeyInput
                                            formFieldStatus={ formFields['motivo'].status }
                                            label="Motivo"
                                            name="motivo"
                                            onChange={ handleMotivoChange }
                                            required={cita !== null}
                                            requiredIndicator={cita !== null}
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={motivo}
                                            values={[{ value: '', label: '' }, ...motivos.map(motivo => ({ value: motivo._id, label: motivo.nombre }))]}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <NumberInput
                                            formFieldStatus={ formFieldsSecond['duracion'].status }
                                            label="Duración (min)"
                                            name="duracion"
                                            onChange={ handleInputChangeSecond }
                                            required={ cita !== null }
                                            requiredIndicator={ cita !== null }
                                            setFormFieldValidation={ setFormFieldValidationSecond }
                                            value={ duracion }
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <TextAreaInput
                                            formFieldStatus={ formFields['comentario'].status }
                                            label="Comentario"
                                            name="comentario"
                                            onChange={ handleInputChange }
                                            required={ false }
                                            requiredIndicator={ false }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ comentario }
                                        />
                                    </div>
                                </div>
                                </>}
                                <div className="row">
                                    <div className="col">
                                        {(inactivoFlag) && <p className={styles.helperErrorText}>La fecha seleccionada esta marcada como día inactivo en la configuración del consultorio. ¿Deseas continuar igualmente?</p>}
                                        {(horarioFlag) && <p className={styles.helperErrorText}>El periodo de tiempo seleccionado esta fuera del horario configurado para el consultorio. ¿Deseas continuar igualmente?</p>}
                                        {(empalmadaFlag) && <p className={styles.helperErrorText}>El periodo de tiempo seleccionado se empalma con otra cita previamente agendada. ¿Deseas continuar igualmente?</p>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-6">
                                        <LightButton
                                            block={true}
                                            icon="X"
                                            marginTop={false}
                                            onClick={ hide }
                                            text="Cancelar"
                                            type="button"
                                        />
                                    </div>
                                    <div className='col-xs-12 col-sm-12 col-md-6'>
                                        <PrimaryButton
                                            block={true}
                                            disabled={formValidationStatus === 'checking'}
                                            icon="Check"
                                            marginTop={false}
                                            text={(inactivoFlag || horarioFlag || empalmadaFlag) ? "Confirmar" : ((cita === null) ? "Crear" : ((!posponer) ? "Editar" : "Posponer"))}
                                            type="submit"
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </>
                }
            </>
        }
        </>
    ) : <Forbidden />
}

CitaPacienteModal.propTypes = {
  paciente: PropTypes.string.isRequired,
  cita: PropTypes.object,
  hide: PropTypes.func.isRequired,
  posponer: PropTypes.bool,
}